export default __webpack_public_path__ + "static/media/cog-solid.a871bc5e.svg";